import { createStore } from "vuex";
import * as Cookies from "js-cookie";
import getters from "./getters";
import actions from "./actions";
import mutations from "./mutations";
import state from "./state";
Cookies.set("userOnline", true);
export const store = createStore({
  state, 
  mutations,
  getters,
  actions,
});
